import React from 'react'
import classNames from 'classnames'
import withStyles from '@material-ui/core/styles/withStyles'
import LatestSearchesBox from '../../../components/LatestSearchesBox'
import { connect } from 'react-redux'
import { searchActions } from '../../../actions'
import HistoryWrapperAndIcon from './HistoryWrapperAndIcon'
import CustomSearchbar from './CustomSearchbar'
import RelativeWrapper from './RelativeWrapper'

const WrapperSearch = withStyles({
  wrapperSearch: {
    paddingTop: 16,
    paddingRight: 8,
    paddingBottom: 16,
    paddingLeft: 8,
    background: '#F7F7F7',
    position: 'relative',
    zIndex: 999,
  },
})(({ classes, children, ...rest }) => {
  return (
    <div {...rest} className={classNames(classes.wrapperSearch, 'container')}>
      {children}
    </div>
  )
})

class SearchBarLayout extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      shouldShowLatestSearches: false,
    }
  }

  showLatestSearches = () => {
    this.setState({ shouldShowLatestSearches: !this.state.shouldShowLatestSearches })
  }

  hideLatestSearches = () => {
    this.setState({ shouldShowLatestSearches: false })
  }

  runSearch = (query) => {
    this.hideLatestSearches()
    this.setState({ searchTerm: query })
    this.props.changeTerm(query)
  }

  changePopper = () => {
    this.props.changeClosePopper(false)
    // this.props.popperOpen = false
  }

  latestSearchesIcon = () => {
    return this.state.shouldShowLatestSearches ? '#757575' : '#7575759c'
  }

  render() {
    const { shouldShowLatestSearches } = this.state
    const { runSearch, showLatestSearches, latestSearchesIcon } = this
    const { searchTerm = '' } = this.props
    return (
      <WrapperSearch>
        <RelativeWrapper>
          <CustomSearchbar searchTerm={searchTerm} runSearch={runSearch} changePopper={this.changePopper} />
          <HistoryWrapperAndIcon
            showLatestSearches={showLatestSearches}
            searchTerm={searchTerm}
            latestSearchesIcon={latestSearchesIcon}
            changePopper={this.changePopper}
          />
        </RelativeWrapper>
        <RelativeWrapper>
          <LatestSearchesBox runSearch={runSearch} shouldShowBox={shouldShowLatestSearches} />
        </RelativeWrapper>
      </WrapperSearch>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    searchTerm: state.search.term,
    popperOpen: state.search.popperOpen,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeTerm: (term) => {
      dispatch(searchActions.changeTerm(term))
    },
    changeClosePopper: (popper) => {
      dispatch(searchActions.changeClosePopper(popper))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBarLayout)
